import { IonIcon } from '@ionic/react';
import { card, chevronForward } from 'ionicons/icons';
import { noop } from 'lodash';
import React from 'react';

interface LinkedCasinoCardProps {
  name: string;
  address: string;
  playerId?: string;
  verification?: string;
  verifiedDate?: string;
  onActionClick?: () => void;
}

const formatVerifiedDate = (dateStr: string): string => {
  try {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch (e) {
    return '';
  }
};

const getVerificationClass = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'verified':
      return 'verification-badge--verified';
    case 'pending':
      return 'verification-badge--pending';
    default:
      return 'verification-badge--unverified';
  }
};

export const LinkedCasinoCard: React.FC<LinkedCasinoCardProps> = ({
  name,
  address,
  playerId,
  verification,
  verifiedDate,
  onActionClick = () => noop,
}) => {
  return (
    <div className="linked-casino-card">
      <div className="info">
        <h3 className="remove-margins body-bold heading">{name}</h3>
        <p className="remove-margins body-small description">{address}</p>
      </div>

      {playerId ? (
        <div className="card-info body-small-bold">
          <IonIcon className="icon" icon={card} />
          <div className="card-info__player">
            <span className="card-info__player-id">{playerId}</span>
            {verification && (
              <div className={`verification-badge ${getVerificationClass(verification)}`}>
                <span className="verification-badge__status">{verification}</span>
                {verification === 'verified' && verifiedDate && (
                  <span className="verification-badge__date">{formatVerifiedDate(verifiedDate)}</span>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <a
          href="javascript:void(0)"
          onClick={() => onActionClick()}
          className="body-small-bold link-player-id "
          data-testid="casinoCardAction"
        >
          Link Player ID
          <IonIcon className="icon" icon={chevronForward} />
        </a>
      )}
    </div>
  );
};

export default LinkedCasinoCard;
